// Utils
import editorStoreConnect from '../../../../components/editor/store/components/editorStoreConnect';
import { sendAmplitudeEvent } from '../../../../analytics/amplitudeService';

// Actions
import { editorStyleChange } from '../../../../components/editor/store/editorActions';

// Components
import RichTextTool from './RichTextTool';

// Utils
import { getEditorState } from '../../../../components/editor/store/reducers/editorStoreSelector';
import editorGetCurrentBlock from '../../../../components/editor/customRichUtils/editorState/editorGetCurrentBlock';

// Constants
import {
    STYLE_COMMAND_TYPES,
    STYLE_TYPES,
    STYLE_COMMANDS,
} from '../../../../components/editor/richText/richTextConstants';
import { AMPLITUDE_USER_PROPS, TRACKED_FEATURES } from '../../../../../common/analytics/statsConstants';
import { EVENT_TYPE_NAMES } from '../../../../../common/analytics/amplitudeEventTypesUtil';
import editorGetCurrentInlineStyle from '../../../../components/editor/customRichUtils/editorState/editorGetCurrentInlineStyle';

const mapStateToProps = (state, ownProps) => {
    const styleCommand = ownProps.item?.toolSettings?.styleCommand || ownProps.styleCommand || '';

    const editorState = getEditorState(state);
    if (!editorState) return { isActive: false };

    const styleType = STYLE_COMMAND_TYPES[styleCommand];
    const currentBlock = editorGetCurrentBlock(editorState);
    if (!currentBlock) return { isActive: false };

    const blockType = currentBlock.getType();

    if (styleType === STYLE_TYPES.BLOCK) return { isActive: blockType === styleCommand };
    if (
        styleCommand === STYLE_COMMANDS.BOLD &&
        (blockType === STYLE_COMMANDS.HEADING || blockType === STYLE_COMMANDS.LARGE_HEADING)
    ) {
        return { disabled: true };
    }
    if (styleCommand === STYLE_COMMANDS.ITALIC && blockType === STYLE_COMMANDS.BLOCKQUOTE) return { disabled: true };

    const inlineStyle = editorGetCurrentInlineStyle(editorState);
    return { isActive: inlineStyle.has(styleCommand) };
};

const mapEditorDispatchToProps = (dispatch, ownProps) => ({
    onPointerDown: (event) => {
        const styleCommand = ownProps.item?.toolSettings?.styleCommand || ownProps.styleCommand || '';

        event.preventDefault();
        const styleChangeAction = editorStyleChange({ styleCommand });
        dispatch(styleChangeAction);

        if (styleCommand === STYLE_COMMANDS.CHECKLIST) {
            sendAmplitudeEvent({
                eventType: EVENT_TYPE_NAMES.CHECKLIST,
                userProperties: {
                    [AMPLITUDE_USER_PROPS.FEATURE]: { [TRACKED_FEATURES.CHECKLIST]: true },
                },
            });
        }
    },
});

export default editorStoreConnect(mapStateToProps, mapEditorDispatchToProps)(RichTextTool);
